import { combineReducers } from "redux";
import authReducer from "./authReducer";
import sessionReducer from "./sessionReducer";

// Combinar los reducer de la aplicación
export default combineReducers({
    authReducer,
    sessionReducer
});
